import styled from "styled-components";
import { useThemeContext } from "../../../../../theme/ThemeContext";
import { Theme } from "../../../../../../constant/Theme";
import useGetOrderItemInrixVolumeParams, {
  InrixVolumeTimePeriod,
} from "./GetOrderItemInrixVolumeParams";
import { useFeatureContext } from "../../../../../../context/Feature";

const TimePeriodControlWrapper = styled.div`
  display: flex;
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
`;

const TimePeriodOption = styled.label<{ $active: boolean; $isDark: boolean }>`
  flex: 1;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $active, $isDark }) =>
    $isDark ?
      $active ? "#00587c"
      : "#2b2b2b"
    : $active ? "#00587c"
    : "#ffffff"};
  color: ${({ $active, $isDark }) =>
    $active ? "#ffffff"
    : $isDark ? "#ffffff"
    : "#000000"} !important;
  cursor: pointer;
  font-size: 18px;
  user-select: none;

  &:hover {
    background-color: ${({ $active, $isDark }) =>
      $isDark ?
        $active ? "#004967"
        : "#3d3d3d"
      : $active ? "#004967"
      : "#a6a5a5"};
  }

  &:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  &:not(:last-child) {
    border-right: 2px solid #00587c;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
`;

const TimePeriodInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const timePeriodOptions = [
  { value: InrixVolumeTimePeriod.ADT, label: "ADT" },
  { value: InrixVolumeTimePeriod.FIFTEEN_MINS, label: "15 mins" },
];

const OrderItemInrixVolumeTimePeriodControl = () => {
  const { theme } = useThemeContext();
  const { timePeriod, handleSelectTimePeriod } =
    useGetOrderItemInrixVolumeParams();
  const isDark = theme === Theme.DARK;
  const { clearFeatures } = useFeatureContext();

  const onChange = (selectedValue: InrixVolumeTimePeriod) => {
    if (selectedValue === timePeriod) {
      return;
    }

    handleSelectTimePeriod(selectedValue);
    clearFeatures();
  };

  return (
    <TimePeriodControlWrapper role="radiogroup" aria-label="Time period">
      {timePeriodOptions.map((option) => (
        <TimePeriodOption
          key={option.value}
          $active={timePeriod === option.value}
          $isDark={isDark}
          onClick={() => onChange(option.value)}
        >
          <TimePeriodInput
            type="radio"
            name="inrix-volume-time-period"
            checked={timePeriod === option.value}
            onChange={() => onChange(option.value)}
          />
          {option.label}
        </TimePeriodOption>
      ))}
    </TimePeriodControlWrapper>
  );
};

export default OrderItemInrixVolumeTimePeriodControl;
